/**
 * Human summary for a run that was produced by a replay, e.g. "Replay of Actions 2 → 5".
 * Returns null for non-replay runs so callers fall back to the normal status/summary.
 * `startAction`/`endAction` are the source run's timeline indices captured at replay time.
 */
const getReplayRunLabel = (log) => {
  const replay = log?.meta?.replay;
  if (!replay) {
    return null;
  }
  if (typeof replay.startAction === 'number' && typeof replay.endAction === 'number') {
    return replay.startAction === replay.endAction ? `Replay of Action ${replay.startAction}` : `Replay of Actions ${replay.startAction} → ${replay.endAction}`;
  }
  return 'Replay';
};

export default getReplayRunLabel;
